import { render, staticRenderFns } from "./alertbox.vue?vue&type=template&id=18afcfc4&scoped=true&"
import script from "./alertbox.vue?vue&type=script&lang=js&"
export * from "./alertbox.vue?vue&type=script&lang=js&"
import style0 from "./alertbox.vue?vue&type=style&index=0&id=18afcfc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18afcfc4",
  null
  
)

export default component.exports